var exports = {
  "kL": "xdde3148b--024733--container",
  "iq": "xdde3148b--024733--image-container",
  "DD": "xdde3148b--024733--title",
  "h_": "xdde3148b--024733--description",
  "x6": "xdde3148b--024733--button",
};

module.exports = exports;
